import type { AccountType } from '~/types/code/code';

/**
 * ページネーション情報
 */
type Pagination = {
  /** 現在のページ番号 */
  currentPage: number;
  /** 1ページ当たりの表示件数 */
  displayCount: number;
};

/**
 * 絞り込み条件
 */
export type AccountListFilterConditions = {
  /** PLAT-ID */
  platId: string;
  /** 従事業務 */
  accountType: AccountType | '';
  /** 氏名（姓） */
  userNameSei: string;
  /** 氏名（名） */
  userNameMei: string;
  /** 利用駅名 */
  stationName: string;
  /** 利用者名 */
  userCompanyName: string;
  /** 集配人名 */
  deliveryCompanyName: string;
  /** 駅エリア検知 */
  stationAreaDetectionFlag: boolean | '';
};

/**
 * アカウント一覧検索条件
 */
export type AccountListSearchConditions = {
  /** ページネーション情報 */
  pagination: Pagination;
  /** 絞り込み条件 */
  filterConditions: AccountListFilterConditions;
  /** ロック中のみ表示 */
  showOnlyLocked: boolean;
};

/**
 * アカウント一覧検索条件ストア
 */
export const useAccountListSearchConditionsStore = defineStore('accountListSearchConditions', {
  state: (): AccountListSearchConditions => ({
    pagination: {
      currentPage: 1,
      displayCount: 10,
    },
    filterConditions: {
      platId: '',
      accountType: '',
      userNameSei: '',
      userNameMei: '',
      stationName: '',
      userCompanyName: '',
      deliveryCompanyName: '',
      stationAreaDetectionFlag: '',
    },
    showOnlyLocked: false,
  }),
  // Stateをセッションストレージに保存する
  persist: {
    storage: piniaPluginPersistedstate.sessionStorage(),
  },
  actions: {
    /**
     * 検索条件をリセットする
     */
    resetSearchConditions() {
      this.$reset();
    },
  },
});
